module.exports = __webpack_public_path__ + "img/eSano_white.e46e4ad1.png";